import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
declare var google: any;

export interface IGoogleUser {
  clientId: string;
  client_id: string;
  credential: string;
  select_by: string;
}

@Injectable({ providedIn: 'root' })
export class OAuthService {
  loaded: boolean = false;
  initializeGoogleOAuth(callback: any) {
    if (this.loaded) return;
    google.accounts.id.initialize({
      client_id: environment.GOOOGLE_CLIENT_ID,
      callback: (response: IGoogleUser) => callback(response),
    });
    this.loaded = true;
  }

  renderGoogleButton(element: any) {
    google.accounts.id.renderButton(element, {
      size: 'large',
      shape: 'pill',
      locale: 'en',
    });
  }
}
